<app-lazy-dropdown
    [label]="label"
    [control]="control"
    placeholder="Select Agent Company"
    [searchControl]="agentFilter"
    [items]="agentList"
    [totalCount]="totalagentCount"
    [offset]="agentOffset"
    [paginationLimit]="paginationLimit"
    (loadMore)="getNextagent()"
    (filterChange)="filteragent($event)"
    (selectionChange)="onSelectionChange($event)"
    [class]="class"
    [multiple]="multiple"
    [showClear]="showClear"
></app-lazy-dropdown>
